import React, { useEffect, useRef, useState } from "react";
import "./group.css";
import {
  Camera,
  EllipsisVertical,
  Heart,
  MessageSquareText,
  MessagesSquare,
  Pencil,
  Trash2,
  Video,
} from "lucide-react";
import ReactPlayer from "react-player";
import Spinner from "../../Spinner/Spinner";
import apiServiceHandler from "../../../service/apiService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { handleLoadComments, updatePosts } from "../../../redux/groupData";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getColorFromName } from "../../../utils/getColor";
import EmojiPicker from "emoji-picker-react";
import HashLoader from "react-spinners/HashLoader";
import { v4 as uuidv4 } from "uuid";
import PostReactionsModal from "./PostReactionsModal";

const isValidUrl = (urlString) => {
  const urlRegex = /^(https?:\/\/|http:\/\/|www\.)[^\s]+$/i;

  return urlRegex.test(urlString);
};

const GroupFeed = ({ post }) => {
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [content, setContent] = useState(post?.content);
  const [photo, setPhoto] = useState(null);
  const [video, setVideo] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [reactionPostId, setReactionPostId] = useState(null);
  const [commentPostId, setCommentPostId] = useState(null);
  const [postComment, setPostCommnent] = useState("");
  const [commentMode, setCommentMode] = useState();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const reactionPickerRef = useRef();
  const commentsInputRef = useRef();
  const isAdmin = userDetails?.admin;
  const userId = userDetails._id;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const pathArr = pathname.split("/");
  const id = pathArr[pathArr.length - 1];
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [noMoreComments, setNoMoreComments] = useState(false);
  const [postComments, setPostComments] = useState([]);
  const [postEmojis, setPostEmojis] = useState([]);
  const loadComments = useSelector((state) => state.groupData.loadComments);
  const limit = 2;
  const [openReactionsModal, setOpenReactionsModal] = useState(false);
  const [currentPostEmojis, setCurrentPostEmojis] = useState(null);
  const userName = useSelector((state) => state.userData.userDetails.name);

  const toggleReactionsModal = (postReactions) => {
    setOpenReactionsModal(!openReactionsModal);
    if (postReactions) {
      setCurrentPostEmojis(postReactions);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        reactionPickerRef.current &&
        !reactionPickerRef.current.contains(event.target)
      ) {
        setReactionPostId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [reactionPickerRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        commentsInputRef.current &&
        !commentsInputRef.current.contains(event.target)
      ) {
        setCommentMode(false);
        setCommentPostId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [commentsInputRef]);

  const handleContentChange = (e) => {
    setContent(e.target.value);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setPhoto(file);

    const imageUrl = URL.createObjectURL(file);
    console.log(imageUrl, "url....");
    setPreviewImage(imageUrl);
  };

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    setVideo(file);

    const videoUrl = URL.createObjectURL(file);
    setPreviewVideo(videoUrl);
  };

  const handleInputFocus = () => {
    setPopoverVisible((prev) => !prev);
  };

  const handleEditMode = () => {
    setEditMode(true);
    setPopoverVisible(false);

    setContent(post?.content);
  };

  const editPost = async () => {
    setLoading(true);
    const data = new FormData();
    if (photo || video) {
      const newMedia = photo ?? video;
      if (newMedia !== post?.media) {
        data.append("media", newMedia);
      }
    }
    data.append("content", content);
    data.append("group", id);
    data.append("_id", post?._id);
    data.append(
      "mediaType",
      photo
        ? "image"
        : video
        ? "video"
        : post?.media && !photo && !video
        ? post?.mediaType
        : "text"
    );

    try {
      const response = await apiServiceHandler("POST", "api/post/edit", data);
      // toastr.success(response.message);
      dispatch(updatePosts(true));
      setContent("");
      setPhoto(null);
      setVideo(null);
      setPreviewImage(null);
      setPreviewVideo(null);
    } catch (error) {
      toastr.error("Failed to Publish the Post. Please Try Again");
    } finally {
      setLoading(false);
      setPopoverVisible(false);
      setEditMode(false);
    }
  };

  const deletePost = async (postId) => {
    const payload = {
      _id: postId,
      status: 0,
    };

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/post/edit",
        payload
      );

      if (response.status) {
        // toastr.success(response.message);
        dispatch(updatePosts(true));
        setPopoverVisible(false);
      } else {
        toastr.error("Failed to delete the post. Please try again.");
      }
    } catch (error) {
      toastr.error("An error occurred. Please try again.");
    }
  };

  const closeEditMode = () => {
    setEditMode(false);
    setPopoverVisible(false);
    setContent("");
    setPhoto(null);
    setVideo(null);
    setPreviewImage(null);
    setPreviewVideo(null);
  };

  const handlereactionPostId = (id) => {
    setReactionPostId(id);
    setCommentMode(false);
    setCommentPostId(null);
  };

  const handlePostComments = (id) => {
    setCommentMode(true);
    setCommentPostId(id);
    setReactionPostId(null);
  };

  const handleReactionUpdate = (updatedReactions) => {
    setPostEmojis(updatedReactions);
  };

  const onEmojiReactionClick = async (emojiData) => {
    const updatedReactions = [...postEmojis, { emoji: emojiData.emoji, userId: userDetails._id, name: userName }]

    const payload = {
      _id: post?._id,
      reacts: updatedReactions,
    };

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/post/edit",
        payload
      );
      // toastr.success(response.message);
      setPostEmojis(updatedReactions);
    } catch (error) {
      toastr.error("Failed to react to the Post. Please Try Again");
    } finally {
      setReactionPostId(null);
    }
  };

  const addComment = async (id) => {
    let updatedComments = [];
    let date = new Date();

    if (id === commentPostId) {
      const newComment = {
        comment: postComment,
        userId: userDetails?._id,
        name: userDetails?.name,
        _id: uuidv4(),
        date: date.toLocaleDateString(),
        time: date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
      };
      updatedComments.push(newComment);
    }

    const payload = {
      _id: post?._id,
      comments: updatedComments,
    };

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/post/edit",
        payload
      );
      // toastr.success(response.message);
      dispatch(handleLoadComments(true));
    } catch (error) {
      toastr.error("Failed to add comment to the Post. Please Try Again");
    } finally {
      setCommentMode(false);
      setCommentPostId(null);
      setPostCommnent("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addComment(post?._id);
    }
  };

  const getPostComments = async (pageNum = 1, postId) => {
    if (!postId) return;
    setLoadingMore(true);
    try {
      const response = await apiServiceHandler(
        "GET",
        `api/post/comment/${postId}?page=${pageNum}`,
        {}
      );

      if (response.status) {
        const comments = response?.data[0]?.comments || [];
        setPostEmojis(response?.data[0].reacts || []);
        if (pageNum === 1) {
          setPostComments(comments);
          setNoMoreComments(comments.length < limit);
        } else {
          if (comments.length < limit) {
            setNoMoreComments(true);
          }

          if (comments.length > 0) {
            setPostComments((prevComments) => [...prevComments, ...comments]);
          }
        }
      }
    } catch (error) {
      toastr.error("Failed to load comments for the post. Please try again.");
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    if (post?._id) {
      getPostComments(1, post._id);
    }
  }, [post?._id]);

  useEffect(() => {
    if (loadComments) {
      getPostComments(page, post?._id);
    }
    dispatch(handleLoadComments(false));
  }, [loadComments]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getPostComments(nextPage, post?._id);
  };

  const formattedDate = (date) => {
    const newDate = new Date(date)

    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // Use 12-hour format (AM/PM)
    };
    
    // Format the date and time
    // const formattedDate = newDate.toLocaleString('en-US', options);
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);
    const finalDate = formattedDate.replace(',', '');
    return finalDate
  }

  return (
    <>
      <div className="group-feed">
        <div className="group-feed-post">
          <div className="group-post-avatar">
            <div
              className="group-post-avatar-text"
              style={{ background: getColorFromName(post?.posted_by) }}
            >
              <div className="avatar-text">
                {post && post.posted_by_image ? (
                  <img
                    className="avatar__image"
                    src={post.posted_by_image}
                    alt="User Avatar"
                  />
                ) : (
                  <div className="user__avatar">
                    {post.posted_by.substr(0, 1)}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="group-feed-post-card">
            <div className="group-feed-post-card-heading">
              <span>
                <span className="name">{post.posted_by}</span>
                {" shared this post on"} <span className="group-post-comment__timestamp">{formattedDate(post?.created_at)}</span> 
              </span>
              {(userId === post?.posted_by_userId || isAdmin) && (
                <span className="group-dropdown-menu">
                  <span onClick={handleInputFocus}>
                    <EllipsisVertical />
                  </span>
                  <div
                    className="dropdown-popover"
                    onMouseLeave={() => setPopoverVisible(false)}
                  >
                    <div
                      className="dropdown-content"
                      style={
                        isPopoverVisible
                          ? { display: "flex" }
                          : { display: "none" }
                      }
                    >
                      <div
                        className="dropdown-item"
                        onClick={() => deletePost(post?._id)}
                      >
                        <Trash2 style={{ width: "20px", height: "20px" }} />
                        Delete Post
                      </div>
                      {userId === post?.posted_by_userId && (
                        <div className="dropdown-item" onClick={handleEditMode}>
                          <Pencil style={{ width: "20px", height: "20px" }} />
                          Edit Post
                        </div>
                      )}
                    </div>
                  </div>
                </span>
              )}
            </div>
            {!editMode ? (
              <div className="group-post-content">
                <p>
                  {post?.content
                    ?.split(/(https?:\/\/[^\s]+)/g)
                    .map((part, index) =>
                      part.match(/https?:\/\/[^\s]+/) ? (
                        <a
                          key={index}
                          href={part}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {part}
                        </a>
                      ) : (
                        part.split("\n").map((line, lineIndex) => (
                          <React.Fragment key={`${index}-${lineIndex}`}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))
                      )
                    )}
                </p>

                {post?.mediaType === "image" ? (
                  <div className="group-post-media">
                    <img src={post.media} alt="Uploaded image" />
                  </div>
                ) : post.mediaType === "video" ? (
                  <div className="group-post-media">
                    <ReactPlayer
                      url={post.media}
                      controls
                      width="100%"
                      height="auto"
                    />
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="group-post-composer-right">
                <div className="group-post-composer-preview">
                  <div className="group-post-composer-media">
                    {/* Conditionally render preview of uploaded image/video or existing media */}
                    {photo ? (
                      <div className="group-post-media">
                        <img src={previewImage} alt="Uploaded preview" />
                      </div>
                    ) : video ? (
                      <div className="group-post-media">
                        <ReactPlayer
                          url={previewVideo}
                          controls
                          width="100%"
                          height="auto"
                        />
                      </div>
                    ) : post.mediaType === "image" ? (
                      <div className="group-post-media">
                        <img src={post?.media} />
                      </div>
                    ) : (
                      <div className="group-post-media">
                        <ReactPlayer
                          url={post?.media}
                          controls
                          width="100%"
                          height="auto"
                        />
                      </div>
                    )}
                  </div>
                  <div className="group-post-composer-text">
                    <div className="group-post-composer-input">
                      <div className="input-wrapper">
                        <textarea
                          type="text"
                          className="textarea-input"
                          placeholder="Write a post, press enter to publish..."
                          value={content}
                          onChange={handleContentChange}
                          rows={4}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="group-post-composer-popover"
                    style={photo || video ? { display: "none" } : {}}
                  >
                    <div className="group-post-composer-label">Add:</div>

                    {/* Photo Upload */}
                    <div className="file-input">
                      <div className="file-input-activator">
                        <label
                          htmlFor="photo-upload"
                          className="file-input-button"
                        >
                          <span className="file-input-icon">
                            <Camera />
                          </span>
                          <span
                            className="button-label"
                            style={{ color: "#604b51" }}
                          >
                            Photo
                          </span>
                        </label>
                        <input
                          id="photo-upload"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleImageUpload}
                        />
                      </div>
                    </div>

                    {/* Video Upload */}
                    <div className="file-input">
                      <div className="file-input-activator">
                        <label
                          htmlFor="video-upload"
                          className="file-input-button"
                        >
                          <span className="file-input-icon">
                            <Video color="#604b51" />
                          </span>
                          <span
                            className="button-label"
                            style={{ color: "#604b51" }}
                          >
                            Video
                          </span>
                        </label>
                        <input
                          id="video-upload"
                          type="file"
                          accept=".mp4, .mkv, .avi, .mov, .flv, .wmv, .webm, .m4v"
                          style={{ display: "none" }}
                          onChange={handleVideoUpload}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Publish Button */}
                  <div className="group-post-composer-footer">
                    <button
                      className="group-post-cancel-button"
                      onClick={closeEditMode}
                    >
                      <span className="group-post-label">Cancel</span>
                    </button>
                    <button
                      className="group-post-composer-button"
                      onClick={editPost}
                      disabled={loading}
                      style={
                        loading
                          ? { backgroundColor: "#268bd9", border: "none" }
                          : {}
                      }
                    >
                      <span className="group-post-label">
                        {loading ? "Saving" : "Save"}
                      </span>
                      {loading && <Spinner />}
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="group-post-footer">
              {postEmojis?.length > 0 &&
                postEmojis?.reverse().slice(0, 3).map((reaction, index) => (
                  <div
                    className="group-post__reactions"
                    key={index}
                    onClick={() => toggleReactionsModal(postEmojis)}
                  >
                    <div className="reaction-tag__container">
                      <div className="reaction-tag__icon-container">
                        <div className="reaction-tag__icon">
                          {reaction?.emoji}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {postEmojis?.length > 3 && (
                <span
                  className="emoji-reaction-count"
                  onClick={() => toggleReactionsModal(postEmojis)}
                >
                  +{postEmojis?.length - 3}
                </span>
              )}
              <div className="group-feed-post-actions">
                <div className="reaction-picker">
                  <div className="group-feed-post-action">
                    <div
                      className="group-post-title-reaction"
                      onClick={() => handlereactionPostId(post?._id)}
                      ref={reactionPickerRef}
                    >
                      <div className="label">React</div>
                      <Heart color="#6b7280" fill="#6b7280" />
                      {reactionPostId === post?._id && (
                        <div className="reaction-post-picker">
                          <EmojiPicker
                            onEmojiClick={(emojiData) =>
                              onEmojiReactionClick(emojiData)
                            }
                            reactionsDefaultOpen={true}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      className="group-post-title-comment"
                      onClick={() => handlePostComments(post?._id)}
                    >
                      <div className="label">Comment</div>
                      <MessageSquareText color="#6b7280" fill="#6b7280" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {commentMode && (
              <div
                className="group-post-comment-composer"
                ref={commentsInputRef}
              >
                <div className="group-post-comment-composer__right">
                  <div className="group-post-composer__preview">
                    <div className="group-post-comment-composer__preview-text">
                      <div className="group-post-composer__input">
                        <div className="group-text-input_input-wrapper">
                          <input
                            type="text"
                            class="text-input__input text-input"
                            placeholder="write a comment..."
                            value={postComment}
                            onChange={(e) => setPostCommnent(e.target.value)}
                            onKeyDown={handleKeyPress}
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {postComments?.length > 0 && (
              <>
                {postComments?.map((comment) => (
                  <div className="group-post-comments">
                    <div className="group-post-comments__avatar">
                      <div className="group-post-comment__avatar">
                        <div
                          className="group-post-comment__avatar-image"
                          style={{
                            background: getColorFromName(comment?.name),
                          }}
                        >
                          <div className="group-post-comment__avatar-text">
                            {comment && comment.posted_by_image ? (
                              <img
                                className="avatar__image"
                                src={comment.posted_by_image}
                                alt="User Avatar"
                              />
                            ) : (
                              <div className="group-post-comment__avatar-text">
                                {comment.name.substr(0, 1)}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="group-post-comment__card">
                      <div className="group-post-comment__heading">
                        <div className="group-post-comment__meta">
                          <div className="group-post-comment__name">
                            {comment.name}
                          </div>
                          <div className="group-post-comment__timestamp">
                            {comment?.date ? comment?.date + "," : ""}{" "}
                            {comment?.time}
                          </div>
                        </div>
                      </div>
                      <div className="group-post-comment__body">
                        <div className="group-post-comment__content">
                          <p>
                            <span>{comment.comment}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {!noMoreComments ? (
                  <button
                    onClick={handleLoadMore}
                    disabled={loadingMore}
                    className="load-more-btn"
                  >
                    {loadingMore ? (
                      <div className="member-loader">
                        <HashLoader color="#d1b794" size={20} />
                        <p>Loading more comments</p>
                      </div>
                    ) : (
                      <span>Load more comments</span>
                    )}
                  </button>
                ) : (
                  page !== 1 && (
                    <p style={{ textAlign: "center", color: "#949a9e" }}>
                      No More Comments.
                    </p>
                  )
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <PostReactionsModal isOpen={openReactionsModal} onClose={toggleReactionsModal} currentPostEmojis={currentPostEmojis} post={post} onReactionsUpdated={handleReactionUpdate} />
    </>
  );
};

export default GroupFeed;
